/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chip'
export default icon
